import React from "react";
import "./NotFoundScreen.scss";
import LayoutWithSideMenu from "../../components/LayoutWithSideMenu";
import Text from "../../components/Text";
import PanelInvisible from "../../components/PanelInvisible";

const NotFoundScreen = () => {
    return (
        <>
            <PanelInvisible>
                <div className="not-found-center">
                    <div className="not-found-title">
                        <i className="fas fa-exclamation-triangle"></i>
                    </div>
                    <div className="not-found-title">
                        <Text value="Error_404" />
                    </div>
                    <div className="not-found-title">
                        <Text value="Page_Not_Found" />
                    </div>
                </div>
            </PanelInvisible>
        </>
    );
};

export default NotFoundScreen;
